module.exports = __webpack_public_path__ + "static/3-c48b90ca2f18516e28ab878044ac2a80.jpg";